<template>
  <div class="footer">
    <div class="a">
<!--         <div class="b">
              <img  src="../assets/footer/zhixian6.png" class="b1">
           </div>
          <div class="c">
              <img  src="../assets/footer/logo1.png" class="c1">
              <h1 class="c2">株式会社　サンシャイン</h1>
              <hr class="c3"/>
              <img src="../assets/footer/cao1.png" class="c4">
              <img src="../assets/footer/huahua.png" class="c5">
              <img  src="../assets/footer/pingping.png" class="c6">
              <span class="c7">Sunshine Corporation</span>
           </div>
          <div class="e">
              <h1  class="e1">本店所在地：</h1>
              <h1  class="e2">岐阜県多治見笠原町上原1254－1</h1>
							<h1  class="e5">Tel：0572-56-5308</h1>
							<h1  class="e6">Email：info@mail.sunshinejp.jp</h1>
              <h1  class="e3">{{ $t("message.Businesscontents") }}：</h1>
              <h1  class="e4">{{ $t("message.Contents1") }}</h1>
           </div> -->
          <div  class="f">
              <!-- <hr class="f1"/> -->
              <h1  class="f2">Copyright©2022 SUNSHINE LLC. All right reserved.</h1>
           </div>       
     </div>
  </div>
</template>
 
<script>
export default {
  name: 'HomeFooter',
  methods: {
    gotop1:function() {
        scrollTo(0,0);
        this.xian=1;
    },
  
    gotop2:function() {
        scrollTo(0,0);
        this.xian=2;
    },
    gotop3:function() {
        scrollTo(0,0);
        this.xian=3;
    }
    },
 data () {
    return {
      xian:1,
    }
  }

}
</script>
 
<style scoped>
  .footer{
    height: 120px;
    background: #81A89E;
  }
  .a{
    position:relative;
    display: inline-flex;
    width:1440px;
    height: 150px;
    background: #81A89E;
    right: 203px;
  }
  /*直线盒子*/
  .b{
    width: 1024px;
    height: 100px;
  }
  /*直线设置*/
  .b1{
    position:absolute;
    width: 1040px;
    height: 26.77px;
    top:50px;
    left:220px;
  }
  /*中间盒子*/
  .c{
    position:absolute;
    width: 400px;
    height: 150px;
    top:160px;
    left:400px;
  }
  /*图标设置*/
  .c1{
    position:absolute;
    width: 70px;
    height: 70px;
    top:15px;
    right:400px;
  }
    /*文字设置*/
  .c2{
    letter-spacing:2px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    font-size: 25px;
    color: #FFFFFF;
    right:80px;
    width: 300px;
    height: 20px;
    }
    /*直线设置*/
  .c3{
    position:absolute;
    width: 285px;
    height: 1px;
    border:none;
    background-color: #FFFFFF;
    top:50px;
    right:91px;
  }
  /*草*/
  .c4{
    position:absolute;
    width: 18px;
    height: 20px;
    top:65px;
    right:358px;
  }
  /*花*/
  .c5{
    position:absolute;
    width: 18px;
    height: 20px;
    top:65px;
    right:318px;
  }
  /*瓶*/
  .c6{
    position:absolute;
    width: 18px;
    height: 20px;
    top:65px;
    right:278px;
  }
  /*英文*/
  .c7{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    width: 170px;
    height: 24px;
    font-size: 15px;
    color: #FFFFFF;
    top:67px;
    right:85px
  }
  /*右面盒子*/
  .e{
    position:absolute;
    width: 360px;
    height: 300px;
    right:180px;
    bottom:90px;
  }
   /*本地所在地*/
  .e1{
    position:absolute;
    font-size: 14px;
    color: #FFFFFF;
    right:0px;
    top:0px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
  }
  /*所在地名称*/
  .e2{
    position:absolute;
    font-size: 14px;
    color: #FFFFFF;
    right:0px;
    top:40px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
  }
  /*事务内容*/
  .e3{
    position:absolute;
    font-size: 14px;
    color: #FFFFFF;
    right:0px;
    top:160px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
  }
  /*内容*/
  .e4{
    position:absolute;
    font-size: 14px;
    color: #FFFFFF;
    right:0px;
    top:200px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
  }
	/*Tel*/
	.e5{
	  position:absolute;
	  font-size: 14px;
	  color: #FFFFFF;
	  right:0px;
	  top:80px;
	  font-family: PingFangSC-Regular;
	  font-weight: 400;
	}
	/*Email*/
	.e6{
	  position:absolute;
	  font-size: 14px;
	  color: #FFFFFF;
	  right:0px;
	  top:120px;
	  font-family: PingFangSC-Regular;
	  font-weight: 400;
	}
  /*下面盒子*/
  .f{
    position:absolute;
    width: 1024px;
    height: 80px;
    top:20px;
  }
  /*直线设置*/
  .f1{
    position:absolute;
    width: 1024px;
    opacity: 0.16;
    left:0px;
    height: 1px;
    border:none;
    background-color: #FFFFFF;
  }
  /*公司名称*/
  .f2{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #FFFFFF;
    top:20px;
    font-weight: 400;
		text-align: center;
		width: 1400px;
  }
</style>